import { Delete, KeyboardArrowRight, MoreHoriz } from "@mui/icons-material";
import { Box, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Typography } from "@mui/material";
import React from "react";
import { timeformatter } from "services/helper";
import { useConfirmDialog } from "./ConfirmDialog";
import { useTranslation } from "react-i18next";
import { showSnackbar } from "services/snackbarHelper";

const ChatContent = ({ channel }) => {
	const { t } = useTranslation(["common"]);
	const { openDialog } = useConfirmDialog();
	const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
	const open = Boolean(anchorEl);

	const onDelete = () => {
		showSnackbar(t("deleteSuccess", { ns: "validation" }), "success");
		console.log("delete");
	};
	const handleDelete = () => {
		openDialog(t("deleteChannel"), t("deleteChannelMessage"), onDelete, handleClose);
	};
	const handleClickListItem = (event: React.MouseEvent<HTMLElement>) => {
		event.preventDefault();
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	return (
		<>
			<Box
				display={"flex"}
				flexDirection={"row"}
				gap={1}
				mb={0.5}
				justifyContent={"space-between"}
				alignItems={"center"}
				overflow={"hidden"}>
				<Typography
					variant="body2"
					color="textSecondary"
					noWrap>
					{channel.datasetName}
				</Typography>
				<Box
					display="flex"
					alignItems={"center"}
					color="text.secondary">
					<Typography variant="body2">{timeformatter(new Date(channel.time * 1000))}</Typography>
					<KeyboardArrowRight sx={{ fontSize: "body1.fontSize" }} />
				</Box>
			</Box>
			<Box
				display={"flex"}
				flexDirection={"row"}
				flex={0.8}
				width={1}>
				<Box
					display={"flex"}
					flexDirection={"column"}
					flex={1}
					overflow="hidden">
					<Typography fontWeight={500}>{channel.channelName}</Typography>
					<Typography
						variant="body2"
						color="textSecondary"
						noWrap>
						{channel.message}
					</Typography>
				</Box>
				<Box
					display={"flex"}
					flexShrink={0}>
					{/* <IconButton onClick={handleClickListItem}>
						<MoreHoriz />
					</IconButton> */}
				</Box>
			</Box>
			<Menu
				anchorEl={anchorEl}
				open={open}
				onClose={handleClose}
				MenuListProps={{
					role: "listbox",
				}}>
				<MenuItem
					onClick={(e) => {
						handleDelete();
					}}
					sx={{ color: "error.main" }}>
					<ListItemIcon>
						<Delete
							fontSize="small"
							color="error"
						/>
					</ListItemIcon>
					<ListItemText sx={{ "& .MuiTypography-root": { fontWeight: 500 } }}>Delete Channel</ListItemText>
				</MenuItem>
			</Menu>
		</>
	);
};

export default ChatContent;
